import { IWasmStoreGeometry, IWasmStoreMarker, TBulkOperations } from "./interfaces";
import WasmStoreMarker from "./wasm-store-marker";
import WasmStoreGeometry from "./wasm-store-geometry";
import { store } from "~/state/store";
import { addBulkItems } from "~/state/map-content/state";

export default class WasmBulkMode {
	#items: Array<WasmStoreMarker | WasmStoreGeometry>;

	#todoItems: Array<TBulkOperations>;

	constructor() {
		this.#items = [];
		this.#todoItems = [];
	}

	createMarker(data: Partial<IWasmStoreMarker>) {
		const marker = new WasmStoreMarker(data, true);

		this.#items.push(marker);

		return marker;
	}

	createGeometry(data: Partial<IWasmStoreGeometry>) {
		const geometry = new WasmStoreGeometry(data, true);

		this.#items.push(geometry);

		return geometry;
	}

	updateMarker(marker: WasmStoreMarker, data: Partial<IWasmStoreMarker>) {
		if (!marker) {
			return;
		}

		marker.bulkMode = true;
		marker.update(data);
		this.#items.push(marker);
	}

	updateGeometry(geometry: WasmStoreGeometry, data: Partial<IWasmStoreGeometry>) {
		if (!geometry) {
			return;
		}

		geometry.bulkMode = true;
		geometry.update(data);
		this.#items.push(geometry);
	}

	removeMarker(marker: WasmStoreMarker) {
		if (!marker) {
			return;
		}

		marker.bulkMode = true;
		marker.destroy();
		this.#items.push(marker);
	}

	removeGeometry(geometry: WasmStoreGeometry) {
		if (!geometry) {
			return;
		}

		geometry.bulkMode = true;
		geometry.destroy();
		this.#items.push(geometry);
	}

	run() {
		for (const item of this.#items) {
			this.#addOperations(item.bulkOperations);
			item.clearBulkOperations();
			item.bulkMode = false;
		}

		if (this.#todoItems.length > 0) {
			store.dispatch(addBulkItems(this.#todoItems));
		}

		this.#todoItems.length = 0;
	}

	#addOperations(operations: Array<TBulkOperations>) {
		for (const operation of operations) {
			this.#todoItems.push(operation);
		}
	}
}
